import React from 'react';
import './WelcomeHome.css';

export function WelcomeHome() {
  return (
    <div className="welcome-page">
      <img
        src={`${process.env.PUBLIC_URL}/img/logo-liceo.png`}
        alt="Liceo Cultural Docente N°8055"
        className="welcome-page__logo"
      />
      <h1 className="welcome-page__title">
        Bienvenido al Sistema de Gestión Académica del Liceo Cultural Docente N°8055
      </h1>
    </div>
  );
}
